import { render, staticRenderFns } from "./readDialog.vue?vue&type=template&id=6f920e0d&scoped=true"
import script from "./readDialog.vue?vue&type=script&lang=js"
export * from "./readDialog.vue?vue&type=script&lang=js"
import style0 from "./readDialog.vue?vue&type=style&index=0&id=6f920e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f920e0d",
  null
  
)

export default component.exports